module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chaptitler-a"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Old China")])]), _vm._v(" "), _c('h3', {
    staticClass: "chaptitle1-a1",
    attrs: {
      "id": "ch1-3"
    }
  }, [_vm._v("DHAMMAPADA"), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter013#rch1fnc",
      "id": "ch1fnc"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dhammapada")]), _vm._v(" (which, according to the Chinese gloss, may be rendered “Scriptural Texts” or “Verses”) is a work of importance in the study of Buddhism. It contains, as its title signifies, authentic texts gathered from ancient canonical books—and these texts are generally connected with some incident or other in the history of Buddha, helping to illustrate everyday life in India at the time when they were written, as well as the method of teaching adopted by the founder of this religion. Not only does the general tone pervading these verses illustrate the spirit of Buddha’s doctrine, but by a critical examination of particular passages, we are enabled to solve some of the difficulties which always attend the interpretation of words and phrases used in a religious sense.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-ats"
  }, [_vm._v("Chinese Version of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dhammapada")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are four principal copies of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dhammapada")]), _vm._v(" in Chinese. The first, approaching most nearly to the Pali, was made by a Shaman “Wei-chi-lan” (and others), who lived during the Wu dynasty, about the beginning of the third century of the Christian era.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The title by which it is known is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fakheu-King")]), _vm._v(" that is, “The Sutra of Law Verses.” The symbol "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kheu")]), _vm._v(" does not necessarily mean “a verse,” but is applied to any sentence or phrase: the rendering “law texts” or “scripture texts” would, therefore, be more correct were it not that in the preface to this work the symbol is explained by “Gatha,” which is stated by Childres "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(sub voce)")]), _vm._v(" to mean “a verse or stanza” or generally “a cloka or anushtubh stanza.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Buddhist works in China are of great value for an exact knowledge of that religion, because they are faithful versions of works everywhere known in India, not only during the early period of its history, but also throughout its development—or, to put it into plain figures, the books found in China afford us a consecutive catena of writings dating from at least 100 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(" to "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 600, that is, during a period of 700 years. More than this can scarcely be desired for a perfect study of any religious system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fakheu-King")]), _vm._v(" contains thirty-nine chapters against the twenty-six of the Southern edition, and 760 stanzas against 423. We are told, however, in the preface that the original work consisted of twenty-six chapters and 500 stanzas; and as in Buddhist calculations the next highest round number is frequently used to denote the exact number intended, we have in this statement sufficient evidence to show that the original from which our translation was made consisted of the same chapters, and probably the same number of verses, as that known in the South.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0013-01.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container-ta"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the ninth chapter to the thirty-fifth (with the exception of the thirty-third) the two works contain the same succession of subjects, whilst there are seventy-nine more stanzas in the Chinese than in the Pali throughout the chapters common to each.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("360")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Restraint in the eye is good, good is restraint in the ear. in the nose restraint is good, good is restraint in the tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("361")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the body restraint is good, good is restraint in speech, in thought restraint is good, good is restraint in all things. A Bhikshu, restrained in all things, is freed from all pain.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("362")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He who controls his hand, he who controls his feet, he who controls his speech, he who is well controlled, he who delights inwardly, who is collected, who is solitary and content, him they call Bhikshu.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("363")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bhikshu who controls his mouth, who speaks wisely and calmly, who teaches the meaning and the Law, his word is sweet.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("364")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He who dwells in the Law, delights in the Law, meditates on the Law, follows the Law, that Bhikshu will never fall away from the true Law.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("365")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let him not despise what he has received, nor ever envy others: a mendicant who envies others does not obtain peace of mind.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("366")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A Bhikshu who, though he receives little, does not despise what he has received, even the gods will praise him, if his life is pure, and if he is not slothful.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("367")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He who never identifies himself with his body and soul, and does not grieve over what is no more, he indeed is called a Bhikshu.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("368")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bhikshu who acts with kindness, who is calm in the doctrine of Buddha, will reach the quiet place (Nirvana), cessation of natural desires and happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("369")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("O Bhikshu, empty this boat! if emptied, it will go quickly, having cut off passion and hatred, thou wilt go to Nirvana.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("370")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cut off the five (senses), leave the five, rise above the five? A Bhikshu, who has escaped from the five fetters, he is called Oghatinna, “Saved from the flood.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("371")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meditate, O Bhikshu, and be not heedless! Do not direct thy thought to what gives pleasure! that thou mayest not for thy heedlessness have to swallow the iron ball (in hell) and that thou mayest not cry out when burning “This is pain.”")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("372")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without knowledge there is no meditation, without meditation there is no knowledge; he who has knowledge and meditation is near unto Nirvana.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("373")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A Bhikshu who has entered his empty house, and whose mind is tranquil, feels a more than human delight when he sees the law clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("374")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as he has considered the origin and destruction of the elements (khandha) of the body, he finds happiness and joy which belong to those who know the immortal (Nirvana).")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("375")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And this is the beginning here for a wise Bhikshu: watchfulness over the senses, contentedness, restraint under the Law; keep noble friends whose life is pure, and who are not slothful.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("376")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let him live in charity, let him be perfect in his duties; then in the fulness of delight he will make an end of suffering.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("377")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the Vassika-plant sheds its withered flowers, men should shed passion and hatred, O ye Bhikshus!")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("378")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bhikshu whose body and tongue and mind are quieted, who is collected, and has rejected the baits of the world, he is called Quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("379")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rouse thyself by thyself, examine thyself by thyself, thus self-protected and attentive wilt thou live happily, O Bhikshu!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("380")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For self is the lord of self, self is the refuge of self; therefore, curb thyself as the merchant curbs a good horse.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("381")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bhikshu, full of delight, who is calm in the doctrine of Buddha, will reach the quiet place (Nirvana) cessation of natural desires and happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("382")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He who, even as a young Bhikshu, applies himself to the doctrine of Buddha, brightens up this world, like the moon when free from clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "note-a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter013#ch1fnc",
      "id": "rch1fnc"
    }
  }, [_vm._v("*")]), _vm._v(" From "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Texts from the Buddhist Canon, Commonly Known as Dhammapada")]), _vm._v(", translated by Samuel Beal, London, Trubner & Co., 1878.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab5a6ea4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter013.vue
// module id = 90
// module chunks = 0